import Modal from 'components/shared/Modal'
import { useEffect, useRef } from 'react'

declare global {
	interface Window {
		TidyCal: any
	}
}

const TidyCallModal = ({
	isOpen,
	onModalClose,
	dataPath = null,
}: {
	isOpen?: boolean
	onModalClose?: Function
	dataPath?: string
}) => {
	const embedRef = useRef(null)

	useEffect(() => {
		const script = document.createElement('script')
		script.src = 'https://assets.tidycal.com/js/embed.js'
		script.async = true
		script.onload = () => {
			window.TidyCal.init(embedRef.current)
		}

		document.body.appendChild(script)

		return () => {
			document.body.removeChild(script)
		}
	}, [embedRef.current])

	return (
		<>
			<Modal
				isOpen={isOpen}
				onModalClose={onModalClose}
				showFooter={false}
				contentLabel={'Schedule a call'}
			>
				<div
					ref={embedRef}
					className="tidycal-embed"
					data-path={dataPath ?? 'bramkuijken/15-minute-call'}
				></div>
			</Modal>
		</>
	)
}

TidyCallModal.displayName = 'TidyCallModal'

export default TidyCallModal
